import axios from "axios";

const getToken = () => {
  try {
    return localStorage.getItem("pdfServiceToken");
  } catch {
    return null;
  }
};

const axiosForPdf = axios.create({
  headers: {
    Accept: "application/json",
  },
});

axiosForPdf.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosForPdf;
